<template>
  <div class="monthly-statements container">
    <MinimumPayoutThreshold
      v-if="organization && organization.payoutThreshold"
      :isLoading="isLoading"
      :organization="organization"
      @edit:organization="edit"
    />
    <ContentBlock :loading="isLoading">
      <div slot="instructions">
        <h5>{{ $t('Your Monthly Statement History') }}</h5>
        <p class="f5">{{ $t('All of your previous transactions are displayed here.') }}</p>
      </div>
      <div class="body-content" v-if="!isLoading">
        <table v-if="monthlyStatementsSorted.length !== 0">
          <tr>
            <th>
              <span>{{ $t('Date') }}</span>
            </th>
            <th>
              <span>{{ $t('Amount') }}</span>
            </th>
            <th>
              <span>{{ $t('Download') }}</span>
            </th>
          </tr>
          <tr
            class="content-row"
            v-for="monthlyStatement of monthlyStatementsSorted"
            :key="monthlyStatement.id"
          >
            <td class="paid-at">
              <div class="monthly-statement-date">{{ datePrettifier(monthlyStatement.invoiceDate) }}</div>
              <div class="not-paid" v-if="!monthlyStatement.paidAt">{{ $t('Not Paid Yet') }}</div>
            </td>
            <td>
              <b>{{ monthlyStatement.displayInvoiceTotal }}</b>
            </td>
            <td>
              <a
                class="download"
                :href="monthlyStatement.downloadLink"
                rel="noopener"
                target="_blank"
              >
                <svg>
                  <use xlink:href="#icon-download"></use>
                </svg>
                {{ $t('PDF') }}
              </a>
            </td>
          </tr>
        </table>
        <div class="empty" v-if="organization && monthlyStatementsSorted.length === 0">
          <p class="f5">{{ $t('No monthly statements have been added yet.') }}</p>
        </div>
      </div>
    </ContentBlock>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ContentBlock from '@/core/shared/components/ContentBlock';
import moment from 'moment-timezone';
import MinimumPayoutThreshold from './MinimumPayoutThreshold';

@Component({
  components: {
    ContentBlock,
    MinimumPayoutThreshold,
  },
})
export default class MonthlyStatementsRoute extends Vue {
  get monthlyStatementsSorted () {
    if (this.organization) {
      return [...this.organization.invoices].sort((a, b) => moment(a.invoiceDate).isBefore(moment(b.invoiceDate)));
    } else { return []; }
  }

  get isLoading () {
    return this.$store.state.admin.isFetchingAdmin && this.organization && !this.organization.payoutThreshold;
  }

  get organization () {
    return this.$store.getters.currentOrganization;
  }

  created () {
    this.$store.commit('setTitle', this.$t('Monthly Statements'));
    this.$store.dispatch('getMonthlyStatements');
  }

  datePrettifier (date) {
    return moment.utc(date).format('LL');
  }

  edit (property, value) {
    this.$store.dispatch('storeOrganization', { id: this.organization.id, [property]: value });
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.monthly-statements {
  padding-top: var(--spacingMd);

  & table {
    @apply --f5;

    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border-spacing: 0;
    border-radius: var(--radius);
    border: 0.15rem solid var(--colorGeyser);
    overflow: hidden;

    & th {
      @apply --f6;

      padding: var(--spacingSm);
      text-align: left;
    }

    & tr {
      border-bottom: solid 0.1rem var(--colorGeyser);

      &::last-child {
        border-bottom: none;
      }
    }

    & td {
      padding: var(--spacingSm);
      text-align: left;
      vertical-align: middle;
    }
  }

  & .download {
    @apply --buttonTinyPrimary;

    text-decoration: none;
  }

  & .not-paid {
    @apply --f6;
  }
}
</style>
